import { PromiseUtils } from "../../../Global/Base/Promises/PromiseUtils";
import { EventHelper } from "../../UI.BaseControls/Helpers/EventHelper";
import { PopupMenu } from "./PopupMenu";
/**
     * Toto menu upravuje chování základního menu tak, že si samo hlídá otevírání a zavírání a při opětovném kliku na stejný element se menu zavře
     */
export class PopupMenuSwitchable extends PopupMenu {
    //#region Events
    //#endregion Events

    //#region Listeners
    private _clickListener: EventListener;
    private _keyupListener: EventListener;
    //#endregion Listeners

    //#region Fields
    private _sourceElement: HTMLElement;
    //#endregion Fields

    //#region Properties
    //#endregion Properties

    //#region Constructors
    /**
     * Kdyz je cancelbyclick nastaveno na true, tak se popup zavre pri kliknuti mimo jeho obsah, toto je realizovano tak, ze na window je listener udalosti click a clickCancelled,
     * ktery zavira popup, naopak pokud je klikano do popupu, tak ten si odchytava click sam a dale ho nepropaguje
     *
     * @param sourceElement element, ze ktereho se klikem otevira popup
     * @param innerElement element, ktery se bude v popup menu zobrazovat
     * @param cancelByClick pokud je true, tak se okno automaticky zavre, pokud se klikne mimo okno, defaultne true
     * @param width sirka komponenty jako string (aby se daly zadat i %)
     * @param height vyska komponenty jako string (aby se daly zadat i %)
     * @param top odsazeni od vrchniho okraje stranky jako string (aby se daly zadat i %)
     * @param left odsazeni od leveho okraje stranky jako string (aby se daly zadat i %)
     * @param bottom odsazeni od dolniho okraje stranky
     * @param right odsazeni od praveho okraje stranky
     */
    constructor(sourceElement: HTMLElement, innerElement?: HTMLElement, cancelByClick: boolean = true, width: string = "50%", height: string = "50%", top: string = "25%", left: string = "25%", bottom: string = "25%", right: string = "25%") {
        super(innerElement, cancelByClick, width, height, top, left, bottom, right);

        //this._visible = true;
        this._sourceElement = sourceElement;
        this._setSourceListeners();
        //je zapotrebi nastavit i classlist
        this.setVisibility(true);
    }
    //#endregion Constructors

    //#region Methods
    protected override _setListeners(): void {
        if (this.cancelByClick) {
            // všechny popupy zavíráme pokud došlo ke kliknutí někam do okna (i pokud došlo k zastavení této události - událost "clickCancelled")
            // listener registrujeme až v dalším kliku, aby nezachytil ještě událost, která tento popup otevřela - a hned ho zase nezavřel
            PromiseUtils.delay(0).then(() => {
                window.addEventListener("click",
                    this._bodyClickListener = (_e: MouseEvent) => {
                        if (!this.visible)
                            return;

                        this.setVisibility(false);
                    });
                window.addEventListener("clickCancelled", this._bodyClickListener);
            });
        }

        // kliky do menu ho nezavřou
        this._contentContainer.addEventListener("click", this._popupClickListener = (e: MouseEvent) => e.stopPropagation());
        this._contentContainer.addEventListener("keyup", this._keyupListener = (e: KeyboardEvent) => {
            if (e.keyCode == 13) e.stopPropagation();
        });
    }

    private _setSourceListeners(): void {
        this._sourceElement.addEventListener("click", this._clickListener = (e: MouseEvent) => {
            // pokud je menu zobrazené a znovu klikám na stejný element, tak ho pouze zavřu
            if (this.visible) {
                this.setVisibility(false);
            } else {
                // pokud není otevřené, tak zruším událost kliknutí - tím se ihned v tomto kroku zavřou všechna popup menu
                EventHelper.stopPropagation(e);
                // a pak menu zobrazím
                this.setVisibility(true);
            }
        });
        //this._sourceElement.addEventListener("keyup", this._keyupListener = (e: KeyboardEvent) => e.stopPropagation());
    }

    /**
     * Nastaveni viditelnosti komponenty
     * @param visible boolean
     */
    public override setVisibility(visible: boolean): void {
        this._visible = visible;
        this._contentContainer.style.display = visible ? "" : "none";

        this._sourceElement.classList.toggle("isActive", visible);

        this.onVisibilityChanged.trigger(this, this.visible);
    }

    public override dispose(): void {
        super.dispose();

        this._sourceElement.removeEventListener("click", this._clickListener);
        this._contentContainer.removeEventListener("keyup", this._keyupListener);
    }

    //#endregion Methods
}
